import GalleryCard from 'components/molecules/GalleryCard';
import { FC, ReactElement, useRef, useState } from 'react';
import FontMenu from 'components/molecules/FontMenu';
import {
  //DraggableData,
  DraggableEvent,
  //DraggableEventHandler,
} from 'react-draggable';
import './ShareNftBody.css';
import {
  BottomButtonsCont,
  CloseIconCont,
  DeleteButton,
  ImageCard,
  LinkText,
  LogoCont,
  MainBody,
  MentionText,
  MenuCont,
  //Overlay,
  StoryCont,
  //TestDiv,
  ToggleBackgroundButton,
} from './ShareNftBody.style';
// import { ResizableBox, ResizeCallbackData } from 'react-resizable';
import 'react-resizable/css/styles.css';
// import InputText from 'components/molecules/InputText/SimpleInputText';
import SimpleInputCard from 'components/molecules/Card/SimpleInputCard';
import RoundedIconButton from 'components/atoms/Button/RoundedIconButton';
import StoryMenu from 'components/molecules/StoryMenu';
import { useNavigate } from 'react-router-dom';
// import { Rnd } from 'react-rnd';
// import { Box } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';
// import ZIndexMenu from 'components/molecules/ZIndexMenu';
// import { copyFileSync } from 'fs';
// import { useGesture } from '@use-gesture/react';
import { IStoryItem, StoryType } from 'interfaces/addStory.interface';
import DragAndResizable from 'components/molecules/DragAndResizable';

interface IShareNftBody {
  // data: IStoryData;
  hideStoryUI: () => void;
  // increaseStoryUI: ()=>void;
  // decreaseStoryUI: ()=>void;
}

const storyItems: IStoryItem[] = [
  {
    id: 1,
    position: {
      X: 50,
      Y: 50,
    },
    size: {
      X: 250,
      Y: 380,
    },
    zIndex: 1,
    type: StoryType.NftCard,
  },
];

const BACKGROUND_COLORS = [
  '#405DE6',
  '#5851D8',
  '#833AB4',
  '#C13584',
  '#E1306C',
  '#FD1D1D',
  '#F56040',
  '#F77737',
  '#FCAF45',
  '#FFDC80',
];

const ShareNftBody: FC<IShareNftBody> = ({ hideStoryUI }) => {
  const logo = require('assets/logo.png');
  const plusIcon = require('assets/icons/plus-icon.svg');
  const banIcon = require('assets/icons/ban.svg');
  const tiktokIcon = require('assets/icons/tiktok.svg');
  const verifyIcon = require('assets/icons/verify.svg');

  const storyCont = useRef<HTMLDivElement>(null);
  const deleteButton = useRef<HTMLImageElement>(null);

  const [cardData, setCardData] = useState<IStoryItem[]>(storyItems);
  const [dragging, setDragging] = useState<boolean>(false);
  const [showStoryMenu, setShowStoryMenu] = useState<boolean>(false);
  const [showFontMenu, setShowFontMenu] = useState<boolean>(false);
  //   const [showZIndexMenu, setShowZIndexMenu] = useState<boolean>(false);
  const [currentBgIndex, setCurrentBgIndex] = useState<number>(
    Math.floor(Math.random() * 10)
  );

  const navigate = useNavigate();

  //   const handleZIndexCont = () => {
  //     setShowZIndexMenu(!showZIndexMenu);
  //   };

  const openStoryMenu = () => {
    setShowStoryMenu(true);
  };

  const closeStoryMenu = () => {
    setShowStoryMenu(false);
  };

  const closeFontMenu = () => {
    setShowFontMenu(false);
  };

  const handleAddText = () => {
    const highestIndex = getHighestZIndex();
    let lastId = cardData[cardData.length - 1]?.id || 0;
    setCardData([
      ...cardData,
      {
        id: lastId + 1,
        position: {
          X: 50,
          Y: 50,
        },
        size: {
          X: 80,
          Y: 50,
        },
        type: StoryType.Text,
        zIndex: highestIndex + 1,
        text: '',
      },
    ]);
  };

  const addToStoryBoard = (data: IStoryItem) => {
    const highestIndex = getHighestZIndex();
    let lastId = cardData[cardData.length - 1]?.id || 0;
    setCardData([
      ...cardData,
      { ...data, id: lastId + 1, zIndex: highestIndex + 1 },
    ]);
  };

  function toggleBackgroundColor() {
    let newIndex = currentBgIndex + 1;
    if (currentBgIndex >= BACKGROUND_COLORS.length - 1) {
      newIndex = 0;
    }
    setCurrentBgIndex(newIndex);
  }

  const toggleDrag = (id?: number, e?: DraggableEvent) => {
    if (deleteButton.current && e) {
      const btnRect = deleteButton.current.getBoundingClientRect();
      let mouseEvent = e;
      if (e.type === 'touchend') {
        mouseEvent = e as TouchEvent;
        const clientX = mouseEvent.changedTouches[0].clientX;
        const clientY = mouseEvent.changedTouches[0].clientY;
        if (btnRect.x <= clientX && clientX <= btnRect.x + btnRect.width) {
          if (btnRect.y <= clientY && clientY <= btnRect.y + btnRect.height) {
            if (id) {
              const newCartData = [...cardData].filter(data => data.id !== id);
              setCardData([...newCartData]);
            }
          }
        }
      } else if (e.type === 'mouseup') {
        mouseEvent = e as MouseEvent;
        console.log(mouseEvent.x);
        console.log(mouseEvent.y);
        if (
          btnRect.x <= mouseEvent.x &&
          mouseEvent.x <= btnRect.x + btnRect.width
        ) {
          if (
            btnRect.y <= mouseEvent.y &&
            mouseEvent.y <= btnRect.y + btnRect.height
          ) {
            if (id) {
              const newCartData = [...cardData].filter(data => data.id !== id);
              setCardData([...newCartData]);
            }
          }
        }
      }
      // console.log(mouseEvent.)
    }
    setDragging(!dragging);
  };

  function getHighestZIndex() {
    let highestZindex = 0;
    [...cardData].forEach(item => {
      if (item.zIndex && item.zIndex > highestZindex) {
        highestZindex = item.zIndex;
      }
    });
    console.log(highestZindex);
    return highestZindex;
  }

  const handleZIndex = (id: number) => {
    const highestZindex = getHighestZIndex();
    const tempCardData = [...cardData];
    tempCardData.forEach((item, i) => {
      if (item.id === id) {
        item.zIndex = highestZindex + 1;
      }
    });
    setCardData([...tempCardData]);
  };

  const getCardType = (item: IStoryItem): ReactElement => {
    const cardTypes: { [key in StoryType]: ReactElement } = {
      [StoryType.NftCard]: (
        <GalleryCard
          style={{
            borderRadius: '10px',
            height: '100%',
            width: '100%',
            minHeight: '100%',
            minWidth: '100%',
          }}
        />
      ),
      [StoryType.Text]: (
        <SimpleInputCard initValue={item?.text || ''} setInput={() => {}} />
      ),
      [StoryType.Link]: (
        <LinkText
          href={item?.url || ''}
          target={'_blank'}
          onClick={() => navigate(item?.url || '')}
        >
          {item?.text}
        </LinkText>
      ),
      [StoryType.Mention]: <MentionText>{item?.text}</MentionText>,
      [StoryType.GIF]: (
        <ImageCard
          src={item?.url || ''}
          draggable="false"
          alt="img"
          className="no-user-drag"
        />
      ),
      [StoryType.Sticker]: (
        <ImageCard
          src={item?.url || ''}
          draggable="false"
          alt="img"
          className="no-user-drag"
        />
      ),
    };
    return cardTypes[item.type];
  };

  return (
    <MainBody>
      <LogoCont>
        <img src={logo} alt="logo" height={'100%'} />
      </LogoCont>
      <CloseIconCont onClick={hideStoryUI}>
        <img
          src={plusIcon.default}
          alt="icon"
          width={'100%'}
          height={'100%'}
          style={{
            transform: 'rotate(45deg)',
          }}
        />
      </CloseIconCont>

      <StoryCont
        ref={storyCont}
        style={{ backgroundColor: `${BACKGROUND_COLORS[currentBgIndex]}` }}
      >
        <MenuCont>
          {/* <RoundedIconButton color="yellow" icon={tiktokIcon.default} onClick={handleZIndexCont} /> */}
          <RoundedIconButton
            color="yellow"
            icon={tiktokIcon.default}
            onClick={handleAddText}
          />
          <RoundedIconButton
            color="yellow"
            icon={verifyIcon.default}
            onClick={openStoryMenu}
          />
        </MenuCont>

        {cardData.map((item, i) => (
          <DragAndResizable
            key={item.id}
            id={item.id}
            initialPositionX={item.position.X}
            initialPositionY={item.position.Y}
            initialSizeY={item.size.Y}
            initialSizeX={item.size.X}
            parentElem={storyCont}
            lockAspectRatio={
              item.type === StoryType.NftCard ||
              item.type === StoryType.GIF ||
              item.type === StoryType.Sticker
            }
            toggleDrag={toggleDrag}
            handleZIndex={handleZIndex}
            style={{ zIndex: item.zIndex || 1 }}
          >
            {getCardType(item)}
          </DragAndResizable>
        ))}

        {/* <Overlay style={{ display: `${dragging ? 'block' : 'none'}` }}>
                </Overlay> */}

        {dragging && (
          <DeleteButton src={banIcon.default} alt="icon" ref={deleteButton} />
        )}

        <ToggleBackgroundButton
          onClick={() => toggleBackgroundColor()}
          style={{ backgroundColor: `${BACKGROUND_COLORS[currentBgIndex]}` }}
        />

        {showStoryMenu && (
          <StoryMenu
            addToStoryBoard={addToStoryBoard}
            hideUI={() => closeStoryMenu()}
          />
        )}

        {!showFontMenu && <FontMenu hideUI={() => closeFontMenu()} />}

        {/* {showZIndexMenu && (
                    <ZIndexMenu />
                )} */}

        <></>
      </StoryCont>

      <BottomButtonsCont>
        <NormalButton
          style={{
            padding: '5px 20px',
            background: 'rgb(83, 83, 83)',
            borderRadius: '10px',
            whiteSpace: 'no-break',
          }}
        >
          Share in direct message
        </NormalButton>
        <NormalButton
          style={{
            padding: '5px 20px',
            background: 'rgb(83, 83, 83)',
            borderRadius: '10px',
            whiteSpace: 'no-break',
          }}
        >
          Share in story
        </NormalButton>
      </BottomButtonsCont>
    </MainBody>
  );
};

export default ShareNftBody;
